import yup from "../../../../../../../../validation/yup";

export const validationSchema = yup.object().shape({
    permissions: yup.array()
});
